import gql from 'graphql-tag';
export default gql`
	mutation UpdateModalLogin($isOpen: String) {
		updateModalLogin(isOpen: $isOpen) @client
	}
`;
